import {
  Auth0Client
} from "@auth0/auth0-spa-js";



const parseUser = user => {
  if (user == null) {
    return null;
  }

  //console.log("auth.actions.parseUser:", user);

  const identities = user["https://schemas.joinparked.com/identities"];
  const meta_app = user["https://schemas.joinparked.com/metadata:app"];
  const meta_user = user["https://schemas.joinparked.com/metadata:user"];
  const meta = {
    ...meta_app,
    ...meta_user
  };
  const roles = user["https://schemas.joinparked.com/roles"];
  const social = identities.find(i => i.isSocial);

  const parsed_user = {
    id: user.user_id || user.sub,
    name: social && social.profileData ? social.profileData.name : user.name,
    email: user.email,
    verified: user.email_verified,
    lastName: social && social.profileData ? social.profileData.family_name : user.family_name,
    firstName: social && social.profileData ? social.profileData.given_name : user.given_name,
    gender: user.gender,
    avatar: social && social.profileData ? social.profileData.picture : user.picture,
    locale: user.locale,
    role: roles ? roles[0] : null,
    meta: meta,
    entitykey: meta["EntityKey"] || null
  };

  return parsed_user;
};


export const init = (context, options) => {
  // console.log("store.auth.actions.init", options);

  const auth0 = new Auth0Client({
    domain: "auth.ownli.app",
    client_id: "Lqi8CCypBn99B6khxC233oBtxYnVRVJs",
    audience: "https://partners-api.joinparked.com/",
    cacheLocation: "localstorage",
    useRefreshTokens: true,

    ...options
  });

  context.commit("setAuthClient", auth0);
};

export const getTokenSilently = async (context, options) => {
  // console.log("store.auth.actions.getTokenSilently", options);
  const accessToken = await context.state.client.getTokenSilently();
  return accessToken;
};

export const login = async (context, payload) => {
  // console.log("store.auth.actions.login:", payload);

  await context.state.client.loginWithRedirect({
    //connection: 'google-oauth2',
    prompt: payload && !payload.silent ? 'login' : 'none',
    redirect_uri: `${window.location.protocol}//${window.location.host}/callback`
  });
  
};

export const logout = (context) => {
  context.commit("logout");

  context.state.client.logout({
    returnTo: `${window.location.protocol}//${window.location.host}/`
  });
};

export const handleRedirectCallback = async (context) => {
  let client = context.state.client;
  await client.handleRedirectCallback();

  const accessToken = await client.getTokenSilently();
  const raw_user = await client.getUser();
  const parsed_user = parseUser(raw_user);
  context.commit("setUser", parsed_user);
};
